export const REGULATORY_REPORT_URLS = {
  realEstateTaxation: 'https://secapp.taxes.gov.il',
  salesLawCommissioner: 'https://hoc-hamecher.microsoftcrmportals.com/'
} as const;
